import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88c5e740"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search_box" }
const _hoisted_2 = { class: "stocks-list" }
const _hoisted_3 = {
  key: 0,
  id: "stocks-list"
}
const _hoisted_4 = { class: "vote_top cursor" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "small_logo" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_9 = { class: "d" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "sub_info" }
const _hoisted_12 = {
  key: 1,
  style: {"font-size":"18px","line-height":"26px","color":"#8F929B","margin-top":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_content = _resolveComponent("ag-content")!

  return (_openBlock(), _createBlock(_component_ag_content, null, {
    default: _withCtx(() => [
      _createVNode(_component_ag_box, {
        style: {"flex-direction":"column"},
        dp: "flex",
        height: "100%",
        width: "100%",
        p: "0px 20px 20px 20px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box, { width: "100%" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_ion_searchbar, {
                  debounce: "500",
                  placeholder: "회사명, 종목(주식)코드 검색",
                  onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchKeyword($event)))
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_ag_box, { class: "content_inner" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.searchStakeList.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchStakeList, (stock, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: (stock, idx),
                          class: "vote_company main-deal"
                        }, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", {
                              style: {"width":"100%"},
                              class: "vote_top_left",
                              onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'조합지분 회사 목록', 'clickContent':`${stock.stockItemName}`});_ctx.setCompany(stock)}
                            }, [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("img", {
                                  src: stock.companyLogo ? stock.companyLogo : '/assets/icon/company_default_img.png',
                                  onerror: "this.src='/assets/icon/company_default_img.png'",
                                  class: "img-responsive img-circle"
                                }, null, 8, _hoisted_7),
                                _hoisted_8
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(stock.stockItemName), 1),
                                _createElementVNode("div", _hoisted_11, _toDisplayString(stock.codeNumber), 1)
                              ])
                            ], 8, _hoisted_5)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, " 판매 가능한 조합원 자격이 없습니다. "))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}